import React, { useState, useEffect } from 'react';
import './LugaresImperdibles.css';
import baseURL from '../url';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMapMarkerAlt,
    faCompass,
    faTimes,
    faChevronLeft,
    faChevronRight,
    faClock,
    faStar
} from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';

SwiperCore.use([Navigation, Pagination, Autoplay]);

const LUGARES_DEFAULT = [
    {
        id: 1,
        titulo: 'Cueva de las Lechuzas',
        categoria: 'Parque Nacional',
        etiqueta: '⭐ Imperdible',
        ubicacion: 'Parque Nacional Tingo María',
        imagen: '/imagenes_lugares/cueva_lechuzas.jpg',
        descripcion: 'Impresionante caverna kárstica habitada por guácharos y murciélagos, con estalactitas y estalagmitas milenarias.',
        duracion: '3 a 4 horas',
        nivel: 'Fácil - Para toda la familia'
    },
    {
        id: 2,
        titulo: 'Laguna de los Milagros',
        categoria: 'Ecoturismo',
        etiqueta: '🛶 Naturaleza Mística',
        ubicacion: 'Km 22 Tingo María',
        imagen: '/imagenes_lugares/laguna_milagros.jpg',
        descripcion: 'Espejo de agua cristalina rodeado de selva virgen, leyendas amazónicas, paseos en bote, canopy y gastronomía típica.',
        duracion: 'Medio día o Full Day',
        nivel: 'Fácil - Relajante'
    },
    {
        id: 3,
        titulo: 'Catarata Gloriapata',
        categoria: 'Cataratas & Aventura',
        etiqueta: '🌊 Baño Natural',
        ubicacion: 'Microcuenca Tres de Mayo',
        imagen: '/imagenes_lugares/catarata_gloriapata.jpg',
        descripcion: 'Hermosa caída de 25 metros con piscina natural cristalina, rodeada de orquídeas, mariposas y avistamiento de aves.',
        duracion: 'Full Day (Caminata 45 min)',
        nivel: 'Moderado - Selva'
    },
    {
        id: 4,
        titulo: 'Mirador de la Bella Durmiente',
        categoria: 'Mirador Panorámico',
        etiqueta: '⛰️ Foto Obligatoria',
        ubicacion: 'Cerro de la Cruz / Jacintillo',
        imagen: '/imagenes_lugares/bella_durmiente.jpg',
        descripcion: 'La vista panorámica más icónica de la cadena montañosa con silueta de mujer y el serpenteante río Huallaga.',
        duracion: '2 horas al atardecer',
        nivel: 'Fácil'
    },
    {
        id: 5,
        titulo: 'Rapel en Catarata Honolulu',
        categoria: 'Aventura Extrema',
        etiqueta: '🧗‍♂️ Pura Adrenalina',
        ubicacion: 'Honolulu - Tingo María',
        imagen: '/imagenes_lugares/rapel_honolulu.jpg',
        descripcion: 'Circuito de cañonismo y descenso en rapel por cascadas caudalosas con equipo certificado y guías de montaña.',
        duracion: 'Full Day Aventura',
        nivel: 'Aventura / Intermedio'
    }
];

export default function LugaresImperdibles() {
    const [lugares] = useState(LUGARES_DEFAULT);
    const [lugarSeleccionado, setLugarSeleccionado] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [telefonoContacto, setTelefonoContacto] = useState('');

    useEffect(() => {
        cargarContacto();
    }, []);

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => {
                const contactos = data.contacto || [];
                if (contactos.length > 0 && contactos[0]?.telefono) {
                    setTelefonoContacto(contactos[0].telefono.replace(/\D/g, ''));
                }
            })
            .catch(err => console.error('Error al cargar contacto:', err));
    };

    const abrirDetalle = (lugar) => {
        setLugarSeleccionado(lugar);
        setModalOpen(true);
    };

    const cerrarDetalle = () => {
        setModalOpen(false);
        setLugarSeleccionado(null);
    };

    const consultarPorWhatsapp = (e, lugar) => {
        e.stopPropagation();
        const phone = telefonoContacto || '51962850037';
        const mensaje = `Hola Seylis Tours, quisiera consultar paquetes y tours disponibles para visitar: *${lugar.titulo}* en Tingo María.`;
        const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(mensaje)}`;
        window.open(url, '_blank');
    };

}
